var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProduct = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176.25 177.81"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Product_svg__cls-2{fill:none;stroke:currentColor;stroke-width:11.25px;stroke-miterlimit:10}"))), /*#__PURE__*/React.createElement("g", {
  id: "Product_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Product_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    strokeLinejoin: "bevel",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "11.25px"
  },
  d: "m170.63 51.41-82.5 45-82.5-45"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "Product_svg__cls-2",
  d: "M5.63 51.41v75l82.5 45 82.5-45v-75l-41.25-22.5-41.25-22.5-41.25 22.5-41.25 22.5zM88.13 96.41v75M46.88 28.91l82.5 45"
})))));
export default SvgProduct;